import { Duration } from "src/utils/date";

export function getDateRangeOrDuration(
  dateRange?: [string, string],
  duration?: Duration
) {
  return dateRange && dateRange[0] && dateRange[1]
    ? {
        startDate: dateRange[0],
        endDate: dateRange[1],
      }
    : {
        duration: duration || "P7D",
      };
}
